var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mb-4 mt-3"},[_c('el-card',{attrs:{"shadow":"hover"}},[_c('div',{staticClass:"px-1",attrs:{"slot":"header"},slot:"header"},[_c('h6',{staticClass:"text-center m-0"},[_vm._v("Sales Achievement (Rp)")])]),_c('div',[_c('TableSalesValueAchievement')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }